import { render, staticRenderFns } from "./OnetoOneNew.vue?vue&type=template&id=56da8a94&scoped=true"
import script from "./OnetoOneNew.vue?vue&type=script&lang=js"
export * from "./OnetoOneNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da8a94",
  null
  
)

export default component.exports